var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 30,
    viewBox: "0 0 18 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6102 0.607151C16.4249 0.420916 16.2047 0.273069 15.9621 0.172078C15.7196 0.0710867 15.4595 0.0189366 15.1968 0.018614C14.9341 0.0182915 14.6738 0.0698027 14.4311 0.170198C14.1883 0.270593 13.9677 0.417899 13.7819 0.603679L0.487135 13.8659C0.338823 14.0135 0.221087 14.1889 0.140665 14.3822C0.0602429 14.5754 0.0187146 14.7825 0.0184576 14.9918C0.0182007 15.2011 0.0592201 15.4083 0.139167 15.6017C0.219115 15.7951 0.33642 15.9709 0.484369 16.1189L13.7465 29.4137C14.5286 30.1976 15.7909 30.1992 16.5748 29.4171C17.3587 28.6351 17.3603 27.3728 16.5783 26.5889L5.02378 14.99L16.6227 3.41946C17.3906 2.65341 17.3922 1.3751 16.6102 0.607151Z",
    fill: "#03154D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtn);
export default __webpack_public_path__ + "static/media/back-btn.c597a5fed2bcaf1b45c4d35e4d77bc27.svg";
export { ForwardRef as ReactComponent };